/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// $('.ad_to_cart_coll').click(function(){    
//   var ID = $(this).attr("data-var_id");
//   addItemToCart( ID, 1);    // paste your id product number
//   $('.cart_dr').trigger( "click" );
// });
// function addItemToCart(variant_id, qty) {
//   data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() { 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true  //this code is for prestige theme, is to refresh the cart
//       }));
//     }   
    
//   }); 
 
// }


// Filter by Default first Select In Collection's

// Define filters
var filter1 = document.getElementById("sidebar-filter-v-availability1"); 
var filter2 = document.getElementById("sidebar-filter-v-availability0"); 
var size_filter = filter1.getAttribute("filter_size");
var currentUrl = window.location.href;
var outOfStock = "filter.v.availability=0";
var inStock = "filter.v.availability=1";

if(!currentUrl.includes('search')){
    if (!currentUrl.includes("filter.v.availability")) {
      var defaultUrl = currentUrl.split("?")[0] + "?" + inStock;
      window.location.href = defaultUrl;
    }
    if (size_filter >= 1) {
      filter1.addEventListener("click", function () {
          if (!currentUrl.includes(inStock)) {
              var updatedUrl = currentUrl.split("?")[0] + "?" + inStock;
              window.location.href = updatedUrl;
          }
      });
    } 
    // if(size_filter == 0){
    //         filter2.click();
    // }
    
    if (size_filter == 0) {
      filter2.addEventListener("click", function () {
          if (!currentUrl.includes(outOfStock)) {
              var updatedUrl = currentUrl.split("?")[0] + "?" + outOfStock;
              window.location.href = updatedUrl;
          }
      });
    }
  
}








